import React, { useRef, useState } from 'react';

const FileUpload = ({ onFileSelect }) => {
  const [dragActive, setDragActive] = useState(false);
  const [fileName, setFileName] = useState('');
  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFileName(e.dataTransfer.files[0].name);
      if (onFileSelect) onFileSelect(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
      if (onFileSelect) onFileSelect(e.target.files[0]);
    }
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  return (
    <div
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
      className={`flex flex-col items-center justify-center border-2 rounded-lg p-8 text-center cursor-pointer transition-all duration-200 ${
        dragActive
          ? 'border-blue-500 bg-blue-50'
          : 'border-dashed border-gray-300 bg-white'
      }`}
      onClick={handleClick}
    >
      <input
        type='file'
        ref={inputRef}
        className='hidden'
        onChange={handleChange}
        accept='image/*'
      />
      <p className='mb-2 text-gray-700'>
        {fileName
          ? `Selected file: ${fileName}`
          : 'Drag & drop a file here, or click to select'}
      </p>
      {fileName &&
        inputRef.current &&
        inputRef.current.files &&
        inputRef.current.files[0] &&
        inputRef.current.files[0].type.startsWith('image/') && (
          <img
            src={URL.createObjectURL(inputRef.current.files[0])}
            alt='Preview'
            className='mt-4 max-h-48 rounded shadow'
          />
        )}
    </div>
  );
};

export default FileUpload;
